module.exports = __webpack_public_path__ + "static/media/collapse.3c97c0cd.svg";